import { AxiosError } from "axios";
import { doReload } from "functions/doReload";
import { Col, Container, Row } from "react-bootstrap";

/**
 * Error details display component showing error messages and recovery options.
 *
 * @param props - The component props
 * @param props.error - Optional error object with status and code information
 * @param props.errorMessage - Optional error message text to display
 */
export const ErrorDetails = ({
  error,
  errorMessage,
}: {
  error?: AxiosError | Error;
  errorMessage?: string;
}) => {
  const errorCassette = new URL("../../../public/error-cassette.png", import.meta.url);
  return (
    <Container>
      <Row>
        <Col>
          <h5>I am broken {"\u2639"}</h5>
          {error instanceof AxiosError && (
            <div
              className="d-flex flex-column justify-content-left align-items-center nowrap"
              style={{ whiteSpace: "nowrap" }}
            >
              <h4 className="text-center">
                Error: {error.status} {error.code}
              </h4>
            </div>
          )}
        </Col>
      </Row>
      <Row>
        <Col
          className="d-flex justify-content-center align-items-center"
          xs={{ span: 4 }}
        >
          <img
            src={errorCassette.href}
            className="img"
            alt="Error"
            title="Error"
            width={"350px"}
            height={"350px"}
          />
        </Col>
        <Col
          xs={8}
          className="d-flex flex-column justify-content-center align-items-center"
        >
          <div>
            The error was something like:
            <pre
              className="m-2 p-4 border border-primary rounded bg-primary bg-opacity-50"
              style={{ maxWidth: "800px", maxHeight: "600px", overflow: "auto" }}
            >
              {errorMessage}
            </pre>
            whatever that means,
            <button
              className="button-link mx-1"
              onClick={doReload}
            >
              Refresh
            </button>
            might get back to normal, but if it doesn&apos;t please report this to
            <a
              className="px-1"
              href="mailto:MOSAICBiometrics@astrazeneca.com"
            >
              MOSAICBiometrics@astrazeneca.com
            </a>
            &#128554;
          </div>
        </Col>
      </Row>
    </Container>
  );
};

ErrorDetails.displayName = "ErrorDetails";
